import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IDeleteEventTopicPayload {
    eventTopicId: string
    sagaCB?: {
        onSuccess: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const deleteEventTopic = createSlice({
    name: 'eventTopics/delete-event-topic',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IDeleteEventTopicPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const deleteEventTopicActions = deleteEventTopic.actions
export default deleteEventTopic.reducer
